import { formatDate, needsContract } from '@otc/shared';

/** A generated project is saved, but does not establish a signed contract. */
export function contractCardStatus(legal: {
  contractNo?: string | null;
  contractDate?: string | null;
  contract?: string | null;
  pay: Parameters<typeof needsContract>[0];
  files: { originalName: string }[];
}): string {
  if (legal.contractNo) return legal.contract || `№ ${legal.contractNo}${legal.contractDate ? ` от ${formatDate(legal.contractDate)}` : ''}`;
  if (legal.files.some(file => /^Проект договора №/i.test(file.originalName))) return 'Договор создан';
  if (legal.files.length) return 'Файл договора приложен';
  return needsContract(legal.pay) ? 'Договор не указан' : 'Договор не требуется';
}
